export const isStaging = () =>
{
	const returnValue = !(window.location.href.indexOf('staging') === -1
		&& window.location.href.indexOf('localhost') === -1
		&& window.location.href.indexOf('127.0.0.1') === -1
		&& window.location.href.indexOf('192.168') === -1);
	return returnValue;
};
